"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/dropdown/index.ts
var dropdown_exports = {};
__export(dropdown_exports, {
  ActionDropdown: () => ActionDropdown_default,
  CheckboxDropdown: () => CheckboxDropdown_default,
  CustomDropdown: () => CustomDropdown_default,
  IconDropdown: () => IconDropdown_default,
  SimpleDropdown: () => SimpleDropdown_default,
  dropdownColors: () => dropdownColors
});
module.exports = __toCommonJS(dropdown_exports);
var import_index7 = require("./index.css");

// src/dropdown/actionDropdown/ActionDropdown.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react5 = require("react");

// src/common/contexts/DropdownContext.tsx
var import_react = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var DropdownContext = (0, import_react.createContext)({
  activeDropdownName: "",
  /**
   * This is a dummy function to satisfy the type checker
   * */
  setActiveDropdownName: (name) => {
  }
});
var useDropdownContext = () => (0, import_react.useContext)(DropdownContext);
var DropdownProviderWrapper = ({ children }) => {
  const [activeDropdownName, setActiveDropdownName] = (0, import_react.useState)("");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    DropdownContext.Provider,
    {
      value: { activeDropdownName, setActiveDropdownName },
      children
    }
  );
};

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime2 = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes2
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes2
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/dropdown/CustomDropdown.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react4 = require("react");

// src/button/index.ts
var import_index = require("./index.css");

// src/button/Button.tsx
var import_react3 = require("react");

// src/button/GenericButton.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react2 = require("react");

// src/button/genericButton.module.scss
var genericButton_module_default = {
  "heading-xxl": "genericButton-module__heading-xxl___9NP3V",
  "wrapper": "genericButton-module__wrapper___GQQ0H",
  "heading-xl": "genericButton-module__heading-xl___9RYlD",
  "heading-lg": "genericButton-module__heading-lg___kLhyo",
  "heading-md": "genericButton-module__heading-md___H3D4u",
  "heading-sm": "genericButton-module__heading-sm___zTZqI",
  "heading-xs": "genericButton-module__heading-xs___Ff2UG",
  "body-one": "genericButton-module__body-one___ERWHM",
  "body-two": "genericButton-module__body-two___7YQr-",
  "body-three": "genericButton-module__body-three___fRZrg",
  "body-four": "genericButton-module__body-four___Jxg8b",
  "overline-one": "genericButton-module__overline-one___HYiC4",
  "overline-two": "genericButton-module__overline-two___Oc9vT",
  "overline-three": "genericButton-module__overline-three___H7U-H",
  "strong": "genericButton-module__strong___S1okA",
  "em": "genericButton-module__em___2-8kG",
  "figcaption": "genericButton-module__figcaption___uJG4X",
  "no-margin": "genericButton-module__no-margin___p--A2",
  "button": "genericButton-module__button___-ZvEw",
  "buttonPendingWithHiddenText": "genericButton-module__buttonPendingWithHiddenText___vdKNV",
  "button-withForcedHover": "genericButton-module__button-withForcedHover___wNW5p",
  "button-tertiary": "genericButton-module__button-tertiary___c12xm",
  "button-primary": "genericButton-module__button-primary___QVgSO",
  "button-purple": "genericButton-module__button-purple___pE0jD",
  "button-black": "genericButton-module__button-black___7TWIL",
  "button-white": "genericButton-module__button-white___o5W2c",
  "button-destructive": "genericButton-module__button-destructive___G3NGM",
  "button-secondary": "genericButton-module__button-secondary___nipwy",
  "button-gray": "genericButton-module__button-gray___bk2Qr",
  "button-l": "genericButton-module__button-l___-YVB5",
  "button-iconOnly": "genericButton-module__button-iconOnly___h5FDS",
  "button-m": "genericButton-module__button-m___n6yyw",
  "button-s": "genericButton-module__button-s___RHPNT",
  "button-xs": "genericButton-module__button-xs___5ARP6"
};

// src/button/GenericButton.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var checkButtonPropsForErrors = ({
  icon,
  useAsLink,
  onClick,
  href,
  download,
  text,
  isIconOnly,
  color,
  type
}) => {
  if (color === "gray" && type == "primary" || color === "gray" && type === "tertiary" && !isIconOnly) {
    throw new Error(
      "Expect type prop to be secondary or tertiary(with isIconOnly prop set to true) when color is gray"
    );
  }
  if (color === "purple" && type === "secondary") {
    console.warn(
      "Warning: Button - Secondary Purple color is now deprecated. Please use different color or type. Secondary purple combination will be removed very soon."
    );
  }
  if (useAsLink) {
    if (!href) {
      throw new Error("Expect href prop when useAsLink is true");
    }
    if (onClick) {
      throw new Error(
        "Expect onClick prop to be undefined when useAsLink is true"
      );
    }
  }
  if (!useAsLink) {
    if (!onClick) {
      throw new Error("Expect onClick prop when useAsLink is false");
    }
    if (href) {
      throw new Error(
        "Expect href prop to be undefined when useAsLink is false"
      );
    }
    if (download) {
      throw new Error(
        "Expect download prop to be undefined when useAsLink is false"
      );
    }
  }
  if (isIconOnly) {
    if (!icon) {
      throw new Error("Expect icon prop when isIconOnly is true");
    }
    if (text) {
      throw new Error(
        "Expect text prop to be undefined when isIconOnly is true"
      );
    }
  }
  if (!isIconOnly) {
    if (icon) {
      throw new Error(
        "Expect icon prop to be undefined when isIconOnly is false"
      );
    }
    if (!text) {
      throw new Error("Expect text prop when isIconOnly is false");
    }
  }
};
var spinnerIcon = {
  iconName: "spinner",
  iconStyle: "solid",
  animationType: "spin"
};
var GenericButton = (0, import_react2.forwardRef)(
  ({
    className,
    id,
    disabled = false,
    isPending = false,
    ariaLabel,
    size = "m",
    type = "primary",
    color = "purple",
    buttonTagTypeAttribute = "button",
    /** Text button specific props */
    iconLeft,
    iconRight,
    text,
    /** IconOnly button specific props*/
    isIconOnly = false,
    icon,
    /** <a> specific props */
    useAsLink = false,
    href,
    target,
    download,
    title,
    analyticsCallback,
    /** <button> specific props */
    onClick,
    value,
    name,
    forceHover = false,
    ...rest
  }, ref) => {
    const ButtonTag = useAsLink ? "a" : "button";
    const tagSpecificProps = ButtonTag === "a" ? {
      href: disabled ? void 0 : href,
      target,
      /** Copied from old button component. Only need it for the older browsers,
       *  since modern browsers (~2020+ release year secures these vulnerabilities by default) */
      // Opening links in new tabs with 'target=_blank' is inherently insecure. Unfortunately, we depend
      // on this functionality in a couple of place. Fortunately, it is possible to partially mitigate some of
      // the insecurity of this functionality by using the `rel` tag to block some of the potential exploits.
      // Therefore, we do so here.
      rel: target === "_blank" ? "noopener noreferrer" : void 0,
      download,
      title,
      onClick: analyticsCallback
    } : { type: buttonTagTypeAttribute, onClick, value, name };
    (0, import_react2.useMemo)(
      () => checkButtonPropsForErrors({
        type,
        icon,
        useAsLink,
        onClick,
        href,
        download,
        text,
        isIconOnly,
        color
      }),
      [type, icon, useAsLink, onClick, href, download, text, isIconOnly, color]
    );
    const showIcon = icon && !isPending;
    const showIconLeft = iconLeft && !isPending;
    const showIconRight = iconRight && !isPending || isPending && iconRight && iconLeft;
    const addPendingButtonWithHiddenTextClass = isPending && !icon && !iconLeft && !iconRight;
    const spinnerPosition = iconRight && !iconLeft ? "right" : "left";
    return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
      ButtonTag,
      {
        ref,
        className: (0, import_classnames2.default)(
          genericButton_module_default.button,
          genericButton_module_default[`button-${type}`],
          genericButton_module_default[`button-${color}`],
          genericButton_module_default[`button-${size}`],
          forceHover && genericButton_module_default["button-withForcedHover"],
          isIconOnly && genericButton_module_default["button-iconOnly"],
          addPendingButtonWithHiddenTextClass && genericButton_module_default.buttonPendingWithHiddenText,
          className
        ),
        id,
        disabled,
        ...rest,
        "aria-disabled": disabled || rest["aria-disabled"],
        "aria-label": ariaLabel || rest["aria-label"],
        ...tagSpecificProps,
        children: [
          isPending && spinnerPosition === "left" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon }),
          showIconLeft && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
          showIcon && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...icon }),
          text && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("span", { children: text }),
          showIconRight && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconRight }),
          isPending && spinnerPosition === "right" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon })
        ]
      }
    );
  }
);
var GenericButton_default = (0, import_react2.memo)(GenericButton);

// src/button/Button.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var buttonColors = {
  purple: "purple",
  black: "black",
  gray: "gray",
  white: "white",
  destructive: "destructive"
};
var Button = (0, import_react3.forwardRef)(
  (props, ref) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(GenericButton_default, { ref, ...props })
);
var Button_default = (0, import_react3.memo)(Button);

// src/common/constants/index.ts
var componentSizeToBodyTextSizeMap = {
  l: "body-one",
  m: "body-two",
  s: "body-three",
  xs: "body-four"
};
var dropdownColors = {
  white: "white",
  black: "black",
  gray: "gray"
};

// src/common/helpers/index.ts
var getAriaPropsFromProps = (props) => {
  const ariaProps = {};
  Object.keys(props).forEach((key) => {
    if (key.startsWith("aria-")) {
      ariaProps[key] = props[key];
    }
  });
  return ariaProps;
};

// src/dropdown/customDropdown.module.scss
var customDropdown_module_default = {
  "heading-xxl": "customDropdown-module__heading-xxl___BfDpQ",
  "wrapper": "customDropdown-module__wrapper___Cl6-3",
  "heading-xl": "customDropdown-module__heading-xl___hBTTG",
  "heading-lg": "customDropdown-module__heading-lg___7BsKx",
  "heading-md": "customDropdown-module__heading-md___xxLoj",
  "heading-sm": "customDropdown-module__heading-sm___9iG3J",
  "heading-xs": "customDropdown-module__heading-xs___lrvOk",
  "body-one": "customDropdown-module__body-one___X7Z9b",
  "body-two": "customDropdown-module__body-two___yBWgp",
  "body-three": "customDropdown-module__body-three___wsuRX",
  "body-four": "customDropdown-module__body-four___HuISj",
  "overline-one": "customDropdown-module__overline-one___RpfOR",
  "overline-two": "customDropdown-module__overline-two___vpAsZ",
  "overline-three": "customDropdown-module__overline-three___mVI8k",
  "strong": "customDropdown-module__strong___e5JvH",
  "em": "customDropdown-module__em___-ermV",
  "figcaption": "customDropdown-module__figcaption___GzPqv",
  "no-margin": "customDropdown-module__no-margin___B9wpp",
  "dropdownContainer": "customDropdown-module__dropdownContainer___3BIP8",
  "styleAsFormField": "customDropdown-module__styleAsFormField___xI7en",
  "dropdownLabel": "customDropdown-module__dropdownLabel___v0iA-",
  "dropdownButton": "customDropdown-module__dropdownButton___smtEn",
  "readOnly": "customDropdown-module__readOnly___QcxON",
  "helperSection": "customDropdown-module__helperSection___MS5Cc",
  "dropdownMenuContainer": "customDropdown-module__dropdownMenuContainer___MddCb",
  "dropdownMenuItem": "customDropdown-module__dropdownMenuItem___k0-V-",
  "destructiveDropdownMenuItem": "customDropdown-module__destructiveDropdownMenuItem___EN9g6",
  "selectedDropdownMenuItem": "customDropdown-module__selectedDropdownMenuItem___9szis",
  "disabledDropdownMenuItem": "customDropdown-module__disabledDropdownMenuItem___JXRFz",
  "bottomButtonsContainer": "customDropdown-module__bottomButtonsContainer___t9sSU",
  "open": "customDropdown-module__open___vYM0Z",
  "dropdownContainer-left-menuPlacement": "customDropdown-module__dropdownContainer-left-menuPlacement___qGtiT",
  "dropdownContainer-right-menuPlacement": "customDropdown-module__dropdownContainer-right-menuPlacement___a6Zft",
  "dropdownContainer-bottom-menuVerticalPlacement": "customDropdown-module__dropdownContainer-bottom-menuVerticalPlacement___Ed7JG",
  "dropdownContainer-top-menuVerticalPlacement": "customDropdown-module__dropdownContainer-top-menuVerticalPlacement___XSHG0",
  "dropdownContainer-black": "customDropdown-module__dropdownContainer-black___Vur3p",
  "hasError": "customDropdown-module__hasError___CxxfS",
  "errorSection": "customDropdown-module__errorSection___8w-fJ",
  "activeDropdownButton": "customDropdown-module__activeDropdownButton___I5VEU",
  "dropdownContainer-gray": "customDropdown-module__dropdownContainer-gray___CsmLB",
  "dropdownContainer-white": "customDropdown-module__dropdownContainer-white___p--cG",
  "dropdownContainer-l": "customDropdown-module__dropdownContainer-l___EJinx",
  "dropdownFieldLabel": "customDropdown-module__dropdownFieldLabel___x61Ds",
  "dropdownLabel-thick": "customDropdown-module__dropdownLabel-thick___t8f6S",
  "dropdownLabel-thin": "customDropdown-module__dropdownLabel-thin___PRIj4",
  "dropdownContainer-m": "customDropdown-module__dropdownContainer-m___jkvgP",
  "dropdownContainer-s": "customDropdown-module__dropdownContainer-s___L81BM",
  "dropdownContainer-xs": "customDropdown-module__dropdownContainer-xs___BPccp"
};

// src/dropdown/CustomDropdown.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var CustomDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  children,
  isSomeValueSelected = false,
  icon,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  menuPlacement = "left",
  menuVerticalPlacement = "bottom",
  useDSCOButtonAsTrigger = false,
  triggerButtonProps = {},
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  selectedValueText,
  ...rest
}) => {
  const { activeDropdownName, setActiveDropdownName } = useDropdownContext();
  const dropdownRef = (0, import_react4.useRef)(null);
  const handleClickOutside = (0, import_react4.useCallback)(
    (event) => {
      if (activeDropdownName && dropdownRef.current && event.target instanceof Node && !dropdownRef.current.contains(event.target)) {
        setActiveDropdownName("");
      }
    },
    [dropdownRef, setActiveDropdownName, activeDropdownName]
  );
  const ariaProps = getAriaPropsFromProps(rest);
  (0, import_react4.useEffect)(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleClickOutside);
    };
  }, [handleClickOutside]);
  (0, import_react4.useEffect)(() => {
    if (useDSCOButtonAsTrigger && !triggerButtonProps) {
      console.warn(
        "Warning: `triggerButtonProps` must be defined when `useDSCOButtonAsTrigger` is true."
      );
    }
  }, [useDSCOButtonAsTrigger, triggerButtonProps]);
  (0, import_react4.useEffect)(() => {
    if (color === dropdownColors.white) {
      console.warn(
        "CustomDropdown: `white` variant is deprecated. Use `black` or `gray` and define theme context for light or dark."
      );
    }
  }, [color]);
  const toggleDropdown = (0, import_react4.useCallback)(() => {
    if (activeDropdownName !== name) {
      setActiveDropdownName(name);
    } else {
      setActiveDropdownName("");
    }
  }, [name, activeDropdownName, setActiveDropdownName]);
  const isOpen = (0, import_react4.useMemo)(
    () => activeDropdownName === name,
    [activeDropdownName, name]
  );
  const onKeyDown = (e) => {
    if (e.key === "Escape") {
      e.currentTarget.classList.remove(customDropdown_module_default.open);
    }
  };
  const triggerComponentProps = {
    id: `${name}-dropdown-button`,
    "data-toggle": "dropdown",
    onClick: toggleDropdown,
    disabled: disabled || readOnly,
    ...ariaProps,
    "aria-haspopup": true,
    "aria-label": ariaProps["aria-label"] || `${name} filter dropdown`
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
      "div",
      {
        id: `${name}-dropdown`,
        className: (0, import_classnames3.default)(
          {
            [customDropdown_module_default.open]: isOpen,
            [customDropdown_module_default.hasError]: errorMessage,
            [customDropdown_module_default.readOnly]: readOnly,
            [customDropdown_module_default.styleAsFormField]: styleAsFormField
          },
          customDropdown_module_default.dropdownContainer,
          customDropdown_module_default[`dropdownContainer-${menuPlacement}-menuPlacement`],
          customDropdown_module_default[`dropdownContainer-${menuVerticalPlacement}-menuVerticalPlacement`],
          customDropdown_module_default[`dropdownContainer-${color}`],
          customDropdown_module_default[`dropdownContainer-${size}`],
          className
        ),
        onKeyDown,
        ref: dropdownRef,
        "aria-describedby": ariaProps["aria-describedby"],
        children: [
          styleAsFormField && labelText && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: customDropdown_module_default.dropdownFieldLabel, children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: labelText }) }),
          useDSCOButtonAsTrigger ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            Button_default,
            {
              ...triggerComponentProps,
              ...triggerButtonProps,
              size,
              forceHover: isOpen,
              "aria-label": (triggerButtonProps == null ? void 0 : triggerButtonProps.isIconOnly) ? labelText : triggerButtonProps["aria-label"] || triggerComponentProps["aria-label"]
            }
          ) : /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
            "button",
            {
              ...triggerComponentProps,
              type: "button",
              className: (0, import_classnames3.default)(
                customDropdown_module_default.dropdownButton,
                isOpen && customDropdown_module_default.activeDropdownButton
              ),
              children: [
                isSomeValueSelected && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconName: "check-circle", iconStyle: "solid" }),
                icon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                  FontAwesomeV6Icon_default,
                  {
                    iconName: icon.iconName,
                    iconStyle: icon.iconStyle,
                    title: icon.title,
                    className: icon.className
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                  "span",
                  {
                    className: (0, import_classnames3.default)(
                      customDropdown_module_default.dropdownLabel,
                      customDropdown_module_default[`dropdownLabel-${styleAsFormField ? "thin" : labelType}`]
                    ),
                    children: styleAsFormField ? selectedValueText : labelText
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconStyle: "solid", iconName: "chevron-down" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: customDropdown_module_default.dropdownMenuContainer, children }),
          !errorMessage && (helperMessage || helperIcon) && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: customDropdown_module_default.helperSection, children: [
            helperIcon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
            helperMessage && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: helperMessage })
          ] }),
          errorMessage && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
            "div",
            {
              className: (0, import_classnames3.default)(
                customDropdown_module_default.errorSection,
                customDropdown_module_default.helperSection
              ),
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: errorMessage })
              ]
            }
          )
        ]
      }
    )
  );
};
var WrappedCustomDropdown = (props) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(DropdownProviderWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(CustomDropdown, { ...props }) });
var CustomDropdown_default = (0, import_react4.memo)(WrappedCustomDropdown);

// src/dropdown/actionDropdown/ActionDropdown.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var ActionDropdown = ({
  name,
  className,
  labelText,
  options,
  disabled = false,
  menuPlacement = "left",
  menuVerticalPlacement = "bottom",
  size = "m",
  triggerButtonProps,
  ...rest
}) => {
  const { setActiveDropdownName } = useDropdownContext();
  const onOptionClick = (0, import_react5.useCallback)(
    (optionOnClick) => {
      if (!disabled) {
        optionOnClick();
        setActiveDropdownName("");
      }
    },
    [disabled, setActiveDropdownName]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      disabled,
      menuPlacement,
      menuVerticalPlacement,
      size,
      ...rest,
      useDSCOButtonAsTrigger: true,
      triggerButtonProps,
      children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("ul", { children: options.map((option) => {
        const {
          value,
          label,
          onClick,
          isOptionDisabled,
          isOptionDestructive,
          icon: {
            iconName,
            iconStyle,
            title: iconTitle,
            className: iconClassName
          }
        } = option;
        return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
          "button",
          {
            className: (0, import_classnames4.default)(
              customDropdown_module_default.dropdownMenuItem,
              isOptionDisabled && customDropdown_module_default.disabledDropdownMenuItem,
              isOptionDestructive && customDropdown_module_default.destructiveDropdownMenuItem
            ),
            disabled: isOptionDisabled || disabled,
            type: "button",
            onClick: () => onOptionClick(onClick),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
                FontAwesomeV6Icon_default,
                {
                  iconName,
                  iconStyle,
                  title: iconTitle,
                  className: iconClassName
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("span", { children: label })
            ]
          }
        ) }, value);
      }) })
    }
  );
};
var ActionDropdown_default = ActionDropdown;

// src/dropdown/checkboxDropdown/index.ts
var import_index4 = require("./index.css");

// src/checkbox/index.ts
var import_index3 = require("./index.css");

// src/checkbox/Checkbox.tsx
var import_classnames6 = __toESM(require("classnames"));
var import_react7 = require("react");

// src/typography/index.ts
var import_index2 = require("./index.css");

// src/typography/Typography.tsx
var import_classnames5 = __toESM(require("classnames"));
var import_react6 = require("react");

// ../component-library-styles/typography.module.scss
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "wrapper": "typography-module__wrapper___6sEjE",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw",
  "no-margin": "typography-module__no-margin___dyDRA"
};

// src/typography/Typography.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  noMargin = false,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames5.default)(
        typography_module_default[visualAppearance],
        {
          [typography_module_default["no-margin"]]: noMargin,
          [typography_module_default.wrapper]: semanticTag === "div"
        },
        className
      ),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react6.memo)(Typography);

// src/checkbox/checkbox.module.scss
var checkbox_module_default = {
  "heading-xxl": "checkbox-module__heading-xxl___cBqHQ",
  "wrapper": "checkbox-module__wrapper___2H9Eu",
  "heading-xl": "checkbox-module__heading-xl___wsXhq",
  "heading-lg": "checkbox-module__heading-lg___Y4egE",
  "heading-md": "checkbox-module__heading-md___dpIgb",
  "heading-sm": "checkbox-module__heading-sm___aocGT",
  "heading-xs": "checkbox-module__heading-xs___pHTdK",
  "body-one": "checkbox-module__body-one___2yRw-",
  "body-two": "checkbox-module__body-two___Zusfd",
  "body-three": "checkbox-module__body-three___BCZe2",
  "body-four": "checkbox-module__body-four___SS6BA",
  "overline-one": "checkbox-module__overline-one___LOCte",
  "overline-two": "checkbox-module__overline-two___tBOgK",
  "overline-three": "checkbox-module__overline-three___Kp3-e",
  "strong": "checkbox-module__strong___h-vBq",
  "em": "checkbox-module__em___mR-RD",
  "figcaption": "checkbox-module__figcaption___G4TMR",
  "no-margin": "checkbox-module__no-margin___EdCJO",
  "label": "checkbox-module__label___ooRXo",
  "checkboxLabel": "checkbox-module__checkboxLabel___MK-aH",
  "label-l": "checkbox-module__label-l___7U6JB",
  "checkboxLabel-thick": "checkbox-module__checkboxLabel-thick___ZQVQR",
  "checkboxLabel-thin": "checkbox-module__checkboxLabel-thin___5cgIQ",
  "label-m": "checkbox-module__label-m___CBOxg",
  "label-s": "checkbox-module__label-s___hafkQ",
  "label-xs": "checkbox-module__label-xs___e32xy"
};

// src/checkbox/Checkbox.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var Checkbox = ({
  label,
  checked,
  onChange,
  name,
  value,
  disabled = false,
  indeterminate = false,
  size = "m",
  textThickness = "thin",
  ariaLabel,
  className,
  children,
  ...HTMLAttributes2
}) => {
  const checkboxRef = (0, import_react7.useRef)(null);
  const bodyTextSize = componentSizeToBodyTextSizeMap[size];
  (0, import_react7.useEffect)(() => {
    if (checkboxRef == null ? void 0 : checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [checkboxRef, indeterminate]);
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
    "label",
    {
      className: (0, import_classnames6.default)(
        checkbox_module_default.label,
        checkbox_module_default[`label-${size}`],
        className
      ),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
          "input",
          {
            type: "checkbox",
            ref: checkboxRef,
            name,
            value,
            checked,
            disabled,
            onChange,
            ...HTMLAttributes2,
            className,
            "aria-label": ariaLabel || HTMLAttributes2["aria-label"]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("i", { className: "fa-solid" }),
        label && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
          Typography_default,
          {
            semanticTag: "span",
            className: (0, import_classnames6.default)(
              checkbox_module_default.checkboxLabel,
              checkbox_module_default[`checkboxLabel-${textThickness}`]
            ),
            visualAppearance: bodyTextSize,
            noMargin: true,
            children: label
          }
        ),
        children
      ]
    }
  );
};
var Checkbox_default = Checkbox;

// src/dropdown/checkboxDropdown/CheckboxDropdown.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var CheckboxDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  allOptions,
  checkedOptions = [],
  onChange,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  menuPlacement = "left",
  menuVerticalPlacement = "bottom",
  ...rest
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      labelType,
      color,
      disabled,
      readOnly,
      size,
      isSomeValueSelected: checkedOptions.length > 0,
      helperMessage,
      helperIcon,
      errorMessage,
      styleAsFormField,
      selectedValueText: checkedOptions == null ? void 0 : checkedOptions.map((str) => {
        var _a;
        return (_a = allOptions.find((opt) => opt.value === str)) == null ? void 0 : _a.label;
      }).join(", "),
      menuPlacement,
      menuVerticalPlacement,
      ...rest,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("ul", { children: allOptions.map(({ value, label, isOptionDisabled }) => /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
          Checkbox_default,
          {
            checked: checkedOptions.includes(value),
            disabled: disabled || isOptionDisabled,
            onChange,
            size,
            name: value,
            value,
            label
          }
        ) }, value)) }),
        !rest.hideControls && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: customDropdown_module_default.bottomButtonsContainer, children: [
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            Button_default,
            {
              type: "tertiary",
              color: buttonColors.black,
              text: rest.selectAllText,
              onClick: rest.onSelectAll,
              size
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            Button_default,
            {
              type: "tertiary",
              color: buttonColors.black,
              text: rest.clearAllText,
              onClick: rest.onClearAll,
              size
            }
          )
        ] })
      ]
    }
  );
};
var CheckboxDropdown_default = CheckboxDropdown;

// src/dropdown/iconDropdown/index.ts
var import_index5 = require("./index.css");

// src/dropdown/iconDropdown/IconDropdown.tsx
var import_classnames7 = __toESM(require("classnames"));
var import_react8 = require("react");
var import_jsx_runtime10 = require("react/jsx-runtime");
var IconDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  options,
  selectedOption = {},
  onChange,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  menuPlacement = "left",
  menuVerticalPlacement = "bottom",
  ...rest
}) => {
  const { setActiveDropdownName } = useDropdownContext();
  const onOptionClick = (0, import_react8.useCallback)(
    (option) => {
      if (!disabled && !option.isOptionDisabled) {
        onChange(option);
        setActiveDropdownName("");
      }
    },
    [disabled, onChange, setActiveDropdownName]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      labelType,
      disabled,
      readOnly,
      color,
      icon: selectedOption == null ? void 0 : selectedOption.icon,
      size,
      helperMessage,
      helperIcon,
      errorMessage,
      styleAsFormField,
      selectedValueText: selectedOption == null ? void 0 : selectedOption.label,
      menuPlacement,
      menuVerticalPlacement,
      ...rest,
      children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("ul", { children: options.map((option) => {
        const {
          value,
          label,
          isOptionDisabled,
          icon: {
            iconName,
            iconStyle,
            title: iconTitle,
            className: iconClassName
          }
        } = option;
        return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
          "button",
          {
            className: (0, import_classnames7.default)(
              customDropdown_module_default.dropdownMenuItem,
              isOptionDisabled && customDropdown_module_default.disabledDropdownMenuItem,
              selectedOption.value === value && customDropdown_module_default.selectedDropdownMenuItem
            ),
            disabled: isOptionDisabled || disabled,
            type: "button",
            onClick: () => onOptionClick(option),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                FontAwesomeV6Icon_default,
                {
                  iconName,
                  iconStyle,
                  title: iconTitle,
                  className: iconClassName
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { children: label })
            ]
          }
        ) }, value);
      }) })
    }
  );
};
var IconDropdown_default = IconDropdown;

// src/dropdown/simpleDropdown/index.ts
var import_index6 = require("./index.css");

// src/dropdown/simpleDropdown/SimpleDropdown.tsx
var import_classnames8 = __toESM(require("classnames"));
var import_react9 = require("react");

// src/dropdown/simpleDropdown/simpleDropdown.module.scss
var simpleDropdown_module_default = {
  "heading-xxl": "simpleDropdown-module__heading-xxl___9Bn9p",
  "wrapper": "simpleDropdown-module__wrapper___47Jq6",
  "heading-xl": "simpleDropdown-module__heading-xl___Bs827",
  "heading-lg": "simpleDropdown-module__heading-lg___QaJ50",
  "heading-md": "simpleDropdown-module__heading-md___YiLUI",
  "heading-sm": "simpleDropdown-module__heading-sm___1n7ps",
  "heading-xs": "simpleDropdown-module__heading-xs___xW-Fr",
  "body-one": "simpleDropdown-module__body-one___7rX-Y",
  "body-two": "simpleDropdown-module__body-two___gILBB",
  "body-three": "simpleDropdown-module__body-three___GOcL8",
  "body-four": "simpleDropdown-module__body-four___xRcct",
  "overline-one": "simpleDropdown-module__overline-one___-wIiz",
  "overline-two": "simpleDropdown-module__overline-two___k-quH",
  "overline-three": "simpleDropdown-module__overline-three___GCsDi",
  "strong": "simpleDropdown-module__strong___yTyKW",
  "em": "simpleDropdown-module__em___WbRQ1",
  "figcaption": "simpleDropdown-module__figcaption___9LXRt",
  "no-margin": "simpleDropdown-module__no-margin___WkvcL",
  "dropdownContainer": "simpleDropdown-module__dropdownContainer___Cofpg",
  "styleAsFormField": "simpleDropdown-module__styleAsFormField___Q-XA0",
  "dropdownArrowDiv": "simpleDropdown-module__dropdownArrowDiv___sw7I5",
  "dropdownLabel": "simpleDropdown-module__dropdownLabel___6guyx",
  "iconLeft": "simpleDropdown-module__iconLeft___J-jKr",
  "readOnly": "simpleDropdown-module__readOnly___X-D0o",
  "helperSection": "simpleDropdown-module__helperSection___F4FfB",
  "dropdownContainer-black": "simpleDropdown-module__dropdownContainer-black___IQkAD",
  "hasError": "simpleDropdown-module__hasError___xXvFC",
  "errorSection": "simpleDropdown-module__errorSection___NXOJi",
  "dropdownContainer-gray": "simpleDropdown-module__dropdownContainer-gray___8GY8V",
  "dropdownContainer-white": "simpleDropdown-module__dropdownContainer-white___DjkQ9",
  "dropdownContainer-thin": "simpleDropdown-module__dropdownContainer-thin___F0Lr7",
  "dropdownContainer-l": "simpleDropdown-module__dropdownContainer-l___jHZyS",
  "dropdownContainer-thick": "simpleDropdown-module__dropdownContainer-thick___ZiURJ",
  "dropdownContainer-m": "simpleDropdown-module__dropdownContainer-m___49v5k",
  "dropdownContainer-s": "simpleDropdown-module__dropdownContainer-s___fYXZQ",
  "dropdownContainer-xs": "simpleDropdown-module__dropdownContainer-xs___CaYRZ"
};

// src/dropdown/simpleDropdown/SimpleDropdown.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var SimpleDropdown = ({
  items = [],
  itemGroups = [],
  selectedValue,
  onChange,
  name,
  id,
  className,
  labelText,
  iconLeft,
  helperMessage,
  helperIcon,
  errorMessage,
  dropdownTextThickness = "thick",
  isLabelVisible = true,
  disabled = false,
  readOnly = false,
  color = "black",
  size = "m",
  styleAsFormField = false,
  ...rest
}) => {
  (0, import_react9.useEffect)(() => {
    if (color === "white") {
      console.warn(
        "SimpleDropdown: `white` variant is deprecated. Use `black` or `gray` and define theme context for light or dark."
      );
    }
  }, [color]);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
    "label",
    {
      className: (0, import_classnames8.default)(
        simpleDropdown_module_default.dropdownContainer,
        simpleDropdown_module_default[`dropdownContainer-${size}`],
        simpleDropdown_module_default[`dropdownContainer-${color}`],
        simpleDropdown_module_default[`dropdownContainer-${dropdownTextThickness}`],
        styleAsFormField && simpleDropdown_module_default.styleAsFormField,
        className
      ),
      "aria-describedby": rest["aria-describedby"],
      children: [
        isLabelVisible && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { className: simpleDropdown_module_default.dropdownLabel, children: labelText }),
        /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: simpleDropdown_module_default.dropdownArrowDiv, children: [
          iconLeft && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
            FontAwesomeV6Icon_default,
            {
              ...iconLeft,
              className: (0, import_classnames8.default)(simpleDropdown_module_default.iconLeft, iconLeft.className)
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
            "select",
            {
              name,
              "aria-label": isLabelVisible ? void 0 : labelText,
              onChange,
              value: selectedValue,
              id,
              disabled: disabled || readOnly,
              className: (0, import_classnames8.default)({
                [simpleDropdown_module_default.hasError]: errorMessage,
                [simpleDropdown_module_default.readOnly]: readOnly
              }),
              ...rest,
              children: itemGroups.length > 0 ? itemGroups.map(({ label, groupItems }, index) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("optgroup", { label, children: groupItems.map(({ value, text, disabled: disabled2 }) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("option", { value, disabled: disabled2, children: text }, value)) }, index)) : items.map(({ value, text, disabled: disabled2 }) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("option", { value, disabled: disabled2, children: text }, value))
            }
          )
        ] }),
        !errorMessage && (helperMessage || helperIcon) && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: simpleDropdown_module_default.helperSection, children: [
          helperIcon && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
          helperMessage && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { children: helperMessage })
        ] }),
        errorMessage && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
          "div",
          {
            className: (0, import_classnames8.default)(
              simpleDropdown_module_default.errorSection,
              simpleDropdown_module_default.helperSection
            ),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
              /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { children: errorMessage })
            ]
          }
        )
      ]
    }
  );
};
var SimpleDropdown_default = SimpleDropdown;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ActionDropdown,
  CheckboxDropdown,
  CustomDropdown,
  IconDropdown,
  SimpleDropdown,
  dropdownColors
});
//# sourceMappingURL=index.js.map